import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { STATUS_OPTIONS } from '@cms/utils';
import { PROJECT_LIFECYCLE_VALUES } from './admin-i18n-constants';

export function useAdminI18n() {
  const { t, i18n } = useTranslation('admin');

  const col = (key: string): string => t(`shared.columns.${key}`);
  const act = (key: string): string => t(`shared.actions.${key}`);
  const page = (slug: string, key: string, options?: Record<string, string>): string =>
    t(`pages.${slug}.${key}`, options);

  const statusOptions = useMemo(
    () =>
      STATUS_OPTIONS.map(option => ({
        value: option.value,
        label: t(`shared.status.${option.value}`),
      })),
    [t, i18n.language],
  );

  const allStatusesOption = useMemo(
    () => ({ value: '' as const, label: t('shared.status.all') }),
    [t, i18n.language],
  );

  const projectLifecycleOptions = useMemo(
    () =>
      PROJECT_LIFECYCLE_VALUES.map(value => ({
        value,
        label: t(`shared.lifecycle.${value.toLowerCase()}`),
      })),
    [t, i18n.language],
  );

  const tableLoading = t('shared.table.loading');

  return {
    t,
    col,
    act,
    page,
    statusOptions,
    allStatusesOption,
    projectLifecycleOptions,
    tableLoading,
    language: i18n.language,
  };
}
